import { forwardRef, type LegacyRef } from 'react';
import { useNavigate } from 'react-router-dom';
import assert from 'assert';
import FilteredProjects from './FilteredProjects';
import StateDecorator from '../../../components/utils/state/StateDecorator';
import { isDataState } from '../../../store/data/state';
import { useAppSelector } from '../../../store/hooks';
import ManagementDecorator from '../ManagementDecorator';

function ProjectList(_: object, ref: LegacyRef<HTMLDivElement>): JSX.Element {
  // Retrieve users data.
  const projects = useAppSelector(
    (state) => state.data_slice.externals.projects
  );
  const navigate = useNavigate();
  const refresh = () => {
    navigate(0);
  };

  return ManagementDecorator(ref, () =>
    StateDecorator([projects], ref, () => {
      assert(isDataState(projects));

      return (
        <FilteredProjects
          projects={Object.values(projects.data)}
          refresh={refresh}
        />
      );
    })
  );
}

export default forwardRef(ProjectList);
